import { FaChartLine, FaBookOpen, FaMoneyBill, FaClock, FaHandsHelping, FaArrowUp } from 'react-icons/fa';
import { images } from '../constants'; 


const careerIntro = {
    sub: "Join Our Team",
    heading: "Grow Your Career with Acme Print Shop",
    description: "At Acme Print Shop, we're always looking for creative and detail-oriented individuals to join our growing team. Be part of a fast-paced environment where your skills help bring ideas to life.",
    points: [
        "Work on Custom Printing & Promotional Projects",
        "Collaborate with Designers and Production Experts",
        "Learn Advanced Print Techniques & Tools",
        "Hands-On Experience with Real Client Orders",
        "Contribute to Creative Branding and Product Design",
    ],
    image: {
        src: images.careerIntro,
        alt: "Career-Image",
    },
};

const benefits = [
    {
        id: 1,
        icon: <FaChartLine />,
        title: "Career Growth",
        description: "Advance your career in the print industry with hands-on experience, mentorship, and clear opportunities for promotion.",
    },
    {
        id: 2,
        icon: <FaBookOpen />,
        title: "Skill Development",
        description: "Gain expertise in the latest printing technologies, design tools, and production workflows through ongoing training.",
    },
    {
        id: 3,
        icon: <FaMoneyBill />,
        title: "Competitive Pay",
        description: "Earn competitive wages with added benefits in a role that values your craftsmanship and dedication.",
    },
    {
        id: 4,
        icon: <FaClock />,
        title: "Flexible Hours",
        description: "Enjoy flexible scheduling options that support your productivity, creativity, and work-life balance.",
    },
    {
        id: 5,
        icon: <FaHandsHelping />,
        title: "Team Environment",
        description: "Be part of a supportive and skilled team where collaboration drives every successful print project.",
    },
    {
        id: 6,
        icon: <FaArrowUp />,
        title: "Creative Opportunities",
        description: "Work on custom print and design projects that challenge your creativity and allow your ideas to shine.",
    },
];

const positions = [
    {
        id: 1,
        image: images.position1,
        title: 'Print Operator',
        details: {
            location: 'Production Facility, City',
            timing: 'Full Time',
            hours: 'Shift-Based Hours',
            experience: '1+ Year in Print Production',
            position: 'Multiple Positions Available',
            days: 'Monday to Saturday',
            salary: '$40K - $55K',
            deadline: 'Apply Now - Open Until Filled',
            number: 'For Assistance: Call 123-456-7890',
        },
        overviews: [
            'As a Print Operator, you will be responsible for managing and operating various print equipment to produce high-quality materials. You’ll work closely with the design and finishing teams to ensure print jobs are completed accurately, efficiently, and on schedule.',
        ],
        responsibilities: [
            'Operate digital, offset, or large-format printers according to job specifications.',
            'Perform routine maintenance and troubleshoot printer issues.',
            'Inspect printed output for quality and accuracy.',
            'Load and manage paper, ink, and print media.',
            'Coordinate with designers and supervisors on print requirements.',
            'Ensure timely completion of print orders and meet production targets.',
        ],
        qualifications: [
            'High school diploma or equivalent; technical training preferred.',
            '1+ year of experience operating commercial print equipment.',
            'Basic understanding of color management and print settings.',
            'Attention to detail and ability to follow production guidelines.',
            'Ability to lift materials and stand for extended periods.',
            'Strong time management and teamwork skills.',
        ],
    },
    {
        id: 2,
        image: images.position2,
        title: 'Graphic Designer',
        details: {
            location: 'Design Studio, City',
            timing: 'Full Time',
            hours: 'Standard Business Hours',
            experience: '2+ Years in Graphic Design',
            position: '1 Position Available',
            days: 'Monday to Friday',
            salary: '$45K - $60K',
            deadline: 'Apply Now - Open Until Filled',
            number: 'For Assistance: Call 123-456-7890',
        },
        overviews: [
            'We are looking for a creative and detail-oriented Graphic Designer to develop engaging print-ready artwork for a wide range of products including business cards, flyers, packaging, signage, and promotional materials. The ideal candidate will bring visual concepts to life while maintaining brand consistency and production accuracy.',
        ],
        responsibilities: [
            'Design print-ready layouts for various materials (flyers, brochures, mugs, apparel, etc.).',
            'Collaborate with clients and the print production team to meet project goals.',
            'Prepare and format files for printing according to technical specifications.',
            'Ensure high visual quality, accuracy, and brand alignment in all designs.',
            'Stay updated with design trends and apply best practices.',
            'Manage multiple projects and meet deadlines in a fast-paced environment.',
        ],
        qualifications: [
            'Bachelor’s degree in Graphic Design or a related field.',
            '2+ years of experience in a professional design role, preferably in print.',
            'Proficiency in Adobe Creative Suite (Photoshop, Illustrator, InDesign).',
            'Strong understanding of print file formats, resolution, bleed, and color modes.',
            'Creative mindset with strong typography and layout skills.',
            'Excellent communication and time management abilities.',
        ],
    },
    {
        id: 3,
        image: images.position3,
        title: 'Press Technician',
        details: {
            location: 'Print Production Unit, City',
            timing: 'Full Time',
            hours: 'Rotational Shifts',
            experience: '2+ Years in Press Operation',
            position: '1 Position Available',
            days: 'Monday to Saturday',
            salary: '$48K - $62K',
            deadline: 'Apply Now - Open Until Filled',
            number: 'For Assistance: Call 123-456-7890',
        },
        overviews: [
            'As a Press Technician, you will be responsible for setting up, operating, and maintaining printing presses to produce high-quality output. You will ensure smooth press operation, troubleshoot technical issues, and maintain consistent print quality across various print runs.',
        ],
        responsibilities: [
            'Set up and calibrate printing presses for daily production jobs.',
            'Monitor press performance and adjust settings to maintain print quality.',
            'Perform routine maintenance, cleaning, and minor repairs on press equipment.',
            'Ensure proper ink levels, paper feed, and alignment throughout production.',
            'Collaborate with the prepress and finishing teams to meet production timelines.',
            'Record press settings and production data for quality assurance.',
        ],
        qualifications: [
            'Technical diploma or relevant certification in print or press operation.',
            '2+ years of experience working on commercial or industrial printing presses.',
            'Familiarity with offset, flexographic, or digital press equipment.',
            'Strong mechanical aptitude and troubleshooting skills.',
            'Ability to read and interpret technical job sheets and print specs.',
            'Detail-oriented with good organizational and time management skills.',
        ],
    },
    {
        id: 4,
        image: images.position4,
        title: 'Production Assistant',
        details: {
            location: 'Print Facility, City',
            timing: 'Full Time',
            hours: 'Day Shift',
            experience: '1+ Year in Production or Manufacturing',
            position: '2 Positions Available',
            days: 'Monday to Saturday',
            salary: '$35K - $45K',
            deadline: 'Apply Now - Open Until Filled',
            number: 'For Assistance: Call 123-456-7890',
        },
        overviews: [
            'The Production Assistant will support the print production team in daily operations, ensuring smooth workflow and quality control. This role involves handling materials, organizing print jobs, and assisting with various stages of the production and finishing process.',
        ],
        responsibilities: [
            'Assist in setting up and organizing print jobs for production.',
            'Handle printed materials during cutting, sorting, and packing.',
            'Maintain cleanliness and order in the production area.',
            'Support press and finishing operators as needed.',
            'Check quality of prints and report issues to supervisors.',
            'Manage supplies and restock materials when necessary.',
        ],
        qualifications: [
            'High school diploma or equivalent.',
            '1+ year of experience in a print shop or similar production environment.',
            'Ability to follow instructions and work in a team setting.',
            'Basic understanding of print and finishing equipment is a plus.',
            'Physically fit to lift, carry, and stand for extended periods.',
            'Attention to detail and good organizational habits.',
        ],
    },
    {
        id: 5,
        image: images.position5,
        title: 'Sales Representative',
        details: {
            location: 'Sales Office, City',
            timing: 'Full Time',
            hours: 'Standard Business Hours',
            experience: '2+ Years in B2B or Print Sales',
            position: '1 Position Available',
            days: 'Monday to Friday',
            salary: '$50K - $70K + Commission',
            deadline: 'Apply Now - Open Until Filled',
            number: 'For Assistance: Call 123-456-7890',
        },
        overviews: [
            'We’re looking for a results-driven Sales Representative to promote our print services and products. You’ll work closely with clients to understand their printing needs, offer tailored solutions, and grow long-term customer relationships that drive business success.',
        ],
        responsibilities: [
            'Identify and approach potential clients through calls, visits, and referrals.',
            'Present and explain print products, services, and pricing structures.',
            'Understand client requirements and recommend custom printing solutions.',
            'Prepare and send quotes, manage orders, and ensure customer satisfaction.',
            'Meet sales targets and contribute to revenue growth.',
            'Maintain records of interactions and follow up on leads and opportunities.',
        ],
        qualifications: [
            'Bachelor’s degree in Business, Marketing, or a related field (preferred).',
            '2+ years of proven experience in sales, preferably in printing or creative industries.',
            'Strong interpersonal, negotiation, and presentation skills.',
            'Ability to understand and communicate technical print specifications.',
            'Self-motivated with excellent organizational and time management abilities.',
            'Proficient in CRM tools and Microsoft Office Suite.',
        ],
    },
    {
        id: 6,
        image: images.position6,
        title: 'Shop Manager',
        details: {
            location: 'Main Print Shop, City',
            timing: 'Full Time',
            hours: 'Standard Business Hours',
            experience: '3+ Years in Print or Retail Management',
            position: '1 Position Available',
            days: 'Monday to Saturday',
            salary: '$60K - $80K',
            deadline: 'Apply Now - Open Until Filled',
            number: 'For Assistance: Call 123-456-7890',
        },
        overviews: [
            'The Shop Manager will oversee daily operations of the print shop, ensuring productivity, quality control, and customer satisfaction. This leadership role requires experience in managing teams, coordinating production schedules, and optimizing shop performance.',
        ],
        responsibilities: [
            'Supervise print production staff and daily workflows.',
            'Ensure high-quality output and adherence to deadlines.',
            'Manage inventory, supplies, and equipment maintenance.',
            'Resolve customer concerns and ensure excellent service standards.',
            'Coordinate between departments to ensure smooth operations.',
            'Implement cost-saving measures and efficiency improvements.',
        ],
        qualifications: [
            'Bachelor’s degree or relevant managerial experience.',
            '3+ years of experience in shop or production management.',
            'Strong leadership, organizational, and problem-solving skills.',
            'Knowledge of printing processes and finishing operations.',
            'Ability to multitask and manage pressure in a fast-paced environment.',
            'Excellent communication and team-building abilities.',
        ],
    }

];

export { positions, benefits, careerIntro };